import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CustomPipeModule } from "app/lib/pipes/custom-pipe.module";
import { TranslateModule } from "app/translate/translate.module";
import { UIElementModule } from "app/uiElement/uiElement.module";
import { ServiceNowWrapperComponent } from "./svcnow-wrapper.component";
import { ServiceNowRegisterComponent } from "./comp/register/svcnow-register.component";
import { ServiceNowPairingBaseComponent } from "./comp/pair/svcnow-pairing-base.component";
import { ServiceNowPairingComponent } from "./comp/pair/svcnow-pairing.component";
import { ServiceNowCalendarConfigComponent } from "./comp/svcnow-calendar-config.component";
import { WorkplacePluginService } from "../plugin.service";
import { RegistrationLoaderComponent } from "./comp/registration-loader.component";
import { EmsRegisterComponent } from "./comp/register/ems-register.component";
import { EmsPairingComponent } from "./comp/pair/ems-pairing.component";
import { PairingLoaderComponent } from "./comp/pairing-loader.component";
import { WorkplacePluginPairingService } from "./comp/pair/plugin-pairing.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        CustomPipeModule,
        TranslateModule,
        UIElementModule
    ],
    providers: [
        WorkplacePluginService,
        WorkplacePluginPairingService
    ],
    declarations: [
        ServiceNowWrapperComponent,
        ServiceNowRegisterComponent,
        EmsRegisterComponent,
        ServiceNowPairingBaseComponent,
        ServiceNowPairingComponent,
        EmsPairingComponent,
        ServiceNowCalendarConfigComponent,

        RegistrationLoaderComponent,
        PairingLoaderComponent
    ],
    exports: []
})
export class SvcNowModule { }